import { NUMERIC_VALUE_REGEX } from '@/constants/filterConstants';
import { type ClipboardEvent } from 'react';

// Dictates behaviour when a texted is pasted in the input field
export const onPaste = (e: ClipboardEvent<HTMLInputElement>) => {
  // Get pasted data via clipboard API
  const clipboardData = e.clipboardData.getData('Text') || '';
  // Only allow whole numbers to be pasted
  if (!/^\d+$/.test(clipboardData)) {
    e.preventDefault();
  }
};

// Allows only numbers in the input field
export const allowNumbersOnly = (event: React.KeyboardEvent<HTMLInputElement>) => {
  if (
    event.key.length === 1 &&
    // Restrict non-numeric characters
    !NUMERIC_VALUE_REGEX.test(event.key)
  ) {
    event.preventDefault();
  }
};
